"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Notification_1 = require("@kawaui/icons/build/icons/action/Notification");
const custom_hooks_1 = require("@user-engagement/custom-hooks");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const Styled = __importStar(require("./styled"));
const UNREAD_MESSAGE_COUNT_KEY = 'vp-ue-unread-messages-count';
const NotificationBell = ({ forceMobile, memberId, siteId, path, active }) => {
    const { data } = (0, custom_hooks_1.useQuery)(`${path ? path : ''}/api/notification/v1/messages/stats`, UNREAD_MESSAGE_COUNT_KEY, memberId, siteId, path);
    const { unreadMessageCount, setUnreadMessageCount } = (0, custom_hooks_1.useMessageCenterContext)();
    (0, react_1.useEffect)(() => {
        setUnreadMessageCount((data === null || data === void 0 ? void 0 : data.unreadMessagesCount) || 0);
    }, [data === null || data === void 0 ? void 0 : data.unreadMessagesCount]);
    return ((0, jsx_runtime_1.jsxs)(Styled.BellWrapper, { "$forceMobile": forceMobile, children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: unreadMessageCount > 0, timeout: 500, classNames: "notification-bell-transition", children: (0, jsx_runtime_1.jsx)(Styled.Bubble, { "$forceMobile": forceMobile, children: unreadMessageCount > 0 && (0, jsx_runtime_1.jsx)(Styled.Number, { children: unreadMessageCount }) }) }), (0, jsx_runtime_1.jsx)(Styled.IconWrapper, { "data-testid": "bell-icon", "$forceMobile": forceMobile, "$active": active, children: (0, jsx_runtime_1.jsx)(Notification_1.IconNotification, { width: '100%', height: '100%' }) })] }));
};
NotificationBell.defaultProps = {
    forceMobile: false,
    active: false,
};
exports.default = NotificationBell;
